<div *ngIf="!isAuthenticated" class="auth-error-state" style="text-align: center; padding: 100px 24px;">
  <h2 style="font-size: 28px; color: #0f2f44;"><i class="fa fa-exclamation-triangle" style="margin-right: 8px;"></i>Link
    Dah Tamat Tempoh (Expired)</h2>
  <p style="color: #666; margin-top: 10px; font-size: 16px;">
    Sila buka WhatsApp dan taip #summary untuk dapatkan link masuk yang baharu. Terima kasih! <i
      class="fa fa-hands-praying" style="margin-left: 4px;"></i>
  </p>
</div>

<div *ngIf="isAuthenticated" class="dashboard-layout">

  <aside class="sidebar">
    <div class="logo-section">
      <div>
        <h2>RekodPay</h2>
        <p>Manage Sales. Smooth Operations.</p>
      </div>
    </div>

    <nav class="menu">
      <a class="menu-item active">
        <i class="fa fa-th-large"></i>
        Dashboard
      </a>
    </nav>
  </aside>

  <main class="main-content">

    <header class="topbar">
      <div class="top-actions">
        <i class="fa fa-bell"></i>
        <i class="fa fa-sign-out"></i>
      </div>
    </header>

    <div class="subscription-card" *ngIf="isSubscriber !== '1' && totalOrdersCount > 50">
      <!-- Left Side: QR Image -->
      <div
        style="background: white; padding: 10px; border-radius: 12px; flex-shrink: 0; box-shadow: 0 2px 8px rgba(0,0,0,0.05);">
        <img src="assets/images/GXBankQR.jpg" alt="Maybank Subscription QR"
          style="width: 130px; height: 130px; object-fit: contain; display: block;" />
      </div>

      <!-- Right Side: Content & Actions -->
      <div style="flex-grow: 1;">
        <div
          style="background: #3b82f6; color: white; display: inline-block; padding: 3px 10px; border-radius: 20px; font-size: 11px; font-weight: 600; margin-bottom: 8px; text-transform: uppercase; letter-spacing: 0.5px;">
          RM{{ subscriptionFee }} / month
        </div>

        <h3 style="font-size: 17px; font-weight: 700; color: #1e3a8a; margin: 0 0 6px 0;">
          Thank you for using RekodPay.
        </h3>

        <p style="font-size: 13px; color: #1d4ed8; margin: 0 0 8px 0; line-height: 1.4;">
          Continue using RekodPay for just RM{{ subscriptionFee }}/month to manage your sales, orders, payments,
          expenses and invoices.
        </p>

        <p style="font-size: 13px; color: #1e40af; margin: 0 0 8px 0; line-height: 1.4;">
          After payment, you can share the receipt in <a href="https://wa.me/60178979344" target="_blank"
            style="color: #2563eb; font-weight: 600; text-decoration: underline;">RekodPay WhatsApp Chat</a>
        </p>

        <p style="font-size: 13px; color: #1d4ed8; margin: 0; line-height: 1.4;">
          The payment verification may take some time. You can continue using RekodPay while we verify your payment.
        </p>
      </div>
    </div>

    <div class="tabs-container">
      <button class="tab-btn" [class.active]="activeTab === 'orders'" (click)="switchTab('orders')">
        <i class="fa fa-box" style="margin-right: 6px;"></i> Active Orders
      </button>
      <button class="tab-btn" [class.active]="activeTab === 'products'" (click)="switchTab('products')">
        <i class="fa fa-tags" style="margin-right: 6px;"></i> Product Catalog
      </button>
      <button class="tab-btn" [class.active]="activeTab === 'expenses'" (click)="switchTab('expenses')">
        <i class="fa fa-receipt" style="margin-right: 6px;"></i> Expenses Tracker
      </button>
      <button class="tab-btn" [class.active]="activeTab === 'profile'" (click)="switchTab('profile')">
        <i class="fa fa-building" style="margin-right: 6px;"></i> Merchant Profile
      </button>
    </div>

    <hr class="tab-divider" />

    <div *ngIf="activeTab === 'orders'"
      style="margin: 0 28px 20px 28px; padding: 12px 16px; background: #f0fdf4; border: 1px solid #bbf7d0; border-radius: 8px; font-size: 14px; color: #166534; display: flex; align-items: center; gap: 8px;">
      <i class="fa fa-lightbulb" style="color: #ca8a04;"></i>
      <div>
        Need custom details on your <strong>invoices</strong> and <strong>receipts</strong>? You can configure your
        business info in the
        <a (click)="switchTab('profile')"
          style="color: #0d9488; font-weight: 600; cursor: pointer; text-decoration: underline;">Merchant Profile</a>
        tab.
      </div>
    </div>

    <section class="orders-card" *ngIf="activeTab === 'orders'">
      <div class="card-header-actions" style="display: flex; flex-direction: column; align-items: stretch; gap: 16px;">

        <!-- Top Row: Title & Add Button side by side -->
        <div style="display: flex; justify-content: space-between; align-items: center; width: 100%;">
          <h2 style="margin: 0; font-size: 18px;">Lists of Order</h2>
          <div style="display: flex; flex-direction: column; align-items: flex-end; gap: 4px;">
            <button class="add-product-btn" [disabled]="isSubscriber !== '1' && totalOrdersCount > 50"
              [style.opacity]="(isSubscriber !== '1' && totalOrdersCount > 50) ? '0.6' : '1'"
              [style.cursor]="(isSubscriber !== '1' && totalOrdersCount > 50) ? 'not-allowed' : 'pointer'"
              (click)="isSubscriber !== '1' && totalOrdersCount > 50 ? null : openAddOrderModal()"
              style="white-space: nowrap;">
              <i class="fa fa-lock" *ngIf="isSubscriber !== '1' && totalOrdersCount > 50"
                style="margin-right: 4px;"></i>
              <i class="fa fa-plus" *ngIf="!(isSubscriber !== '1' && totalOrdersCount > 50)"
                style="margin-right: 4px;"></i>
              Add Order
            </button>
            <span *ngIf="isSubscriber !== '1' && totalOrdersCount > 50"
              style="font-size: 11px; color: #dc2626; font-weight: 500;">
              Locked: Please subscribe to continue.
            </span>
          </div>
        </div>

        <!-- Bottom Row: Month & Payment Status Filters -->
        <div style="display: flex; align-items: center; gap: 16px; width: 100%;">
          <!-- Month Filter -->
          <div style="display: flex; align-items: center; gap: 8px; flex: 1;">
            <label for="monthFilter"
              style="font-size: 13px; font-weight: 500; color: #475569; white-space: nowrap;">Month:</label>
            <select id="monthFilter" [(ngModel)]="selectedMonth" (change)="currentPage = 1"
              style="height: 36px; padding: 0 12px; font-size: 13px; border: 1px solid #cbd5e1; border-radius: 6px; background: #ffffff; color: #334155; outline: none; width: 100%;">
              <option value="">All Months</option>
              <option value="01">January</option>
              <option value="02">February</option>
              <option value="03">March</option>
              <option value="04">April</option>
              <option value="05">May</option>
              <option value="06">June</option>
              <option value="07">July</option>
              <option value="08">August</option>
              <option value="09">September</option>
              <option value="10">October</option>
              <option value="11">November</option>
              <option value="12">December</option>
            </select>
          </div>

          <!-- Payment Status Filter -->
          <div style="display: flex; align-items: center; gap: 8px; flex: 1;">
            <label for="statusFilter"
              style="font-size: 13px; font-weight: 500; color: #475569; white-space: nowrap;">Status:</label>
            <select id="statusFilter" [(ngModel)]="selectedStatus" (change)="currentPage = 1"
              style="height: 36px; padding: 0 12px; font-size: 13px; border: 1px solid #cbd5e1; border-radius: 6px; background: #ffffff; color: #334155; outline: none; width: 100%;">
              <option value="">All Status</option>
              <option value="PAID">Paid</option>
              <option value="PENDING">Pending</option>
            </select>
          </div>
        </div>

      </div>

      <div class="card-body-scrollable">
        <table
          style="border-collapse: collapse; width: 100%; background: #ffffff; border: 1px solid #e2e8f0; font-family: inherit; font-size: 14px;">
          <thead>
            <tr
              style="background: #f8fafc; border-bottom: 2px solid #e2e8f0; color: #475569; text-transform: uppercase; font-size: 12px; letter-spacing: 0.05em;">
              <th style="border: 1px solid #e2e8f0; padding: 14px 16px; text-align: left; font-weight: bold;">Order ID
              </th>
              <th style="border: 1px solid #e2e8f0; padding: 14px 16px; text-align: left; font-weight: bold;">Product
                Name
              </th>
              <th style="border: 1px solid #e2e8f0; padding: 14px 16px; text-align: right; font-weight: bold;">Price
                (RM)
              </th>
              <th style="border: 1px solid #e2e8f0; padding: 14px 16px; text-align: center; font-weight: bold;">Quantity
              </th>
              <th style="border: 1px solid #e2e8f0; padding: 14px 16px; text-align: left; font-weight: bold;">Customer
                Name</th>
              <th style="border: 1px solid #e2e8f0; padding: 14px 16px; text-align: left; font-weight: bold;">Phone
                Number
              </th>
              <th style="border: 1px solid #e2e8f0; padding: 14px 16px; text-align: left; font-weight: bold;">Address
              </th>
              <th style="border: 1px solid #e2e8f0; padding: 14px 16px; text-align: right; font-weight: bold;">Total
                Price (RM)
              </th>
              <th style="border: 1px solid #e2e8f0; padding: 14px 16px; text-align: left; font-weight: bold;">Date</th>
              <th style="border: 1px solid #e2e8f0; padding: 14px 16px; text-align: center; font-weight: bold;">Action
              </th>
            </tr>
          </thead>
          <tbody>
            <!-- Switched to paginatedOrders -->
            <tr *ngFor="let order of paginatedOrders"
              style="border-bottom: 1px solid #e2e8f0; transition: background 0.2s;">
              <!-- Order ID -->
              <td style="border: 1px solid #e2e8f0; padding: 16px; vertical-align: middle; background: #fdfdfd;">
                {{ order.orderId }}
              </td>

              <!-- Product Name Column -->
              <td style="border: 1px solid #e2e8f0; padding: 0; vertical-align: top;">
                <div *ngIf="order.items && order.items.length > 0; else singleProductName">
                  <div *ngFor="let item of order.items; let last = last"
                    [style.border-bottom]="last ? 'none' : '1px solid #e2e8f0'"
                    style="padding: 12px 16px; height: 64px; display: flex; align-items: center; box-sizing: border-box;">
                    <div
                      style="overflow: hidden; text-overflow: ellipsis; display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical;">
                      {{ item.productName || item.productDetails }}
                    </div>
                  </div>
                </div>
                <ng-template #singleProductName>
                  <div
                    style="padding: 12px 16px; height: 64px; display: flex; align-items: center; box-sizing: border-box;">
                    {{ order.productDetails }}
                  </div>
                </ng-template>
              </td>

              <!-- Price Column -->
              <td style="border: 1px solid #e2e8f0; padding: 0; vertical-align: top; text-align: right;">
                <div *ngIf="order.items && order.items.length > 0; else singlePriceVal">
                  <div *ngFor="let item of order.items; let last = last"
                    [style.border-bottom]="last ? 'none' : '1px solid #e2e8f0'"
                    style="padding: 12px 16px; height: 64px; color: #334155; display: flex; align-items: center; justify-content: flex-end; box-sizing: border-box;">
                    {{ (item.productPrice || order.productPrice) | number:'1.2-2' }}
                  </div>
                </div>
                <ng-template #singlePriceVal>
                  <div
                    style="padding: 12px 16px; height: 64px; color: #334155; display: flex; align-items: center; justify-content: flex-end; box-sizing: border-box;">
                    {{ order.productPrice | number:'1.2-2' }}
                  </div>
                </ng-template>
              </td>

              <!-- Quantity Column -->
              <td style="border: 1px solid #e2e8f0; padding: 0; vertical-align: top; text-align: center;">
                <div *ngIf="order.items && order.items.length > 0; else singleQtyVal">
                  <div *ngFor="let item of order.items; let last = last"
                    [style.border-bottom]="last ? 'none' : '1px solid #e2e8f0'"
                    style="padding: 12px 16px; height: 64px; display: flex; align-items: center; justify-content: center; box-sizing: border-box;">
                    <span
                      style="background: #e2e8f0; padding: 2px 8px; border-radius: 12px; font-weight: 500; font-size: 13px;">
                      {{ item.quantity }}
                    </span>
                  </div>
                </div>
                <ng-template #singleQtyVal>
                  <div
                    style="padding: 12px 16px; height: 64px; display: flex; align-items: center; justify-content: center; box-sizing: border-box;">
                    <span
                      style="background: #e2e8f0; padding: 2px 8px; border-radius: 12px; font-weight: 500; font-size: 13px;">
                      {{ order.quantity }}
                    </span>
                  </div>
                </ng-template>
              </td>

              <!-- Customer Details -->
              <td style="border: 1px solid #e2e8f0; padding: 16px; vertical-align: middle; color: #334155;">{{
                order.customerName }}</td>
              <td style="border: 1px solid #e2e8f0; padding: 16px; vertical-align: middle; color: #334155;">{{
                order.customerPhoneNumber }}</td>
              <td
                style="border: 1px solid #e2e8f0; padding: 16px; vertical-align: middle; color: #334155; max-width: 180px;">
                {{ order.customerAddress }}</td>

              <!-- Total Price -->
              <td style="border: 1px solid #e2e8f0; padding: 16px; vertical-align: middle; text-align: right;">
                {{ calculateOrderTotal(order) | number:'1.2-2' }}
              </td>

              <!-- Date -->
              <td
                style="border: 1px solid #e2e8f0; padding: 16px; vertical-align: middle; color: #334155; white-space: nowrap;">
                {{ order.createdAt | date:'dd/MM/yyyy hh:mm a' }}
              </td>

              <!-- Action -->
              <td style="border: 1px solid #e2e8f0; padding: 16px; vertical-align: middle; text-align: center;">
                <div class="action-btn-group"
                  style="display: flex; flex-direction: column; gap: 6px; align-items: stretch;">
                  <button class="paid-btn" [class.is-paid]="order.paymentStatus === 'PAID'"
                    [disabled]="order.paymentStatus === 'PAID'" (click)="markAsPaid(order.orderId)"
                    [title]="order.paymentStatus === 'PAID' ? 'Order Already Paid' : 'Mark as Paid'">
                    <i [class]="order.paymentStatus === 'PAID' ? 'fa fa-check-circle' : 'fa fa-money-bill-wave'"
                      style="margin-right: 4px;"></i> {{ order.paymentStatus === 'PAID' ? 'Paid' : 'Mark as Paid' }}
                  </button>
                  <button class="paid-btn" (click)="downloadInvoice(order)">
                    <i class="fa fa-file-pdf" style="margin-right: 4px;"></i> Invoice
                  </button>
                  <button class="paid-btn" (click)="downloadReceipt(order)">
                    <i class="fa fa-file-lines" style="margin-right: 4px;"></i> Receipt
                  </button>
                  <button class="edit-btn" (click)="editOrder(order.id)" title="Update Order">
                    <i class="fa fa-pen-to-square" style="margin-right: 4px;"></i> Update
                  </button>
                  <button class="delete-btn" (click)="deleteOrder(order.orderId)" title="Delete Order">
                    <i class="fa fa-trash" style="margin-right: 4px;"></i> Delete
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Pagination Controls Bar -->
      <div
        style="display: flex; justify-content: space-between; align-items: center; padding: 12px 4px; font-size: 13px; color: #475569;">
        <span>Page {{ currentPage }} of {{ totalPages }}</span>
        <div style="display: flex; gap: 8px;">
          <button (click)="prevPage()" [disabled]="currentPage === 1"
            style="padding: 6px 12px; border: 1px solid #cbd5e1; background: #ffffff; border-radius: 4px; cursor: pointer; [disabled]:opacity-50;">Previous</button>
          <button (click)="nextPage()" [disabled]="currentPage >= totalPages"
            style="padding: 6px 12px; border: 1px solid #cbd5e1; background: #ffffff; border-radius: 4px; cursor: pointer; [disabled]:opacity-50;">Next</button>
        </div>
      </div>
    </section>

    <section class="products-card" *ngIf="activeTab === 'products'">
      <div class="card-header-actions">
        <h2>Product Catalog Management</h2>
        <div style="display: flex; flex-direction: column; align-items: flex-end; gap: 4px;">
          <button class="add-product-btn" [disabled]="isSubscriber !== '1' && totalOrdersCount > 50"
            [style.opacity]="(isSubscriber !== '1' && totalOrdersCount > 50) ? '0.6' : '1'"
            [style.cursor]="(isSubscriber !== '1' && totalOrdersCount > 50) ? 'not-allowed' : 'pointer'"
            (click)="isSubscriber !== '1' && totalOrdersCount > 50 ? null : openAddProductModal()"
            style="white-space: nowrap;">
            <i class="fa fa-lock" *ngIf="isSubscriber !== '1' && totalOrdersCount > 50" style="margin-right: 4px;"></i>
            <i class="fa fa-plus" *ngIf="!(isSubscriber !== '1' && totalOrdersCount > 50)"
              style="margin-right: 4px;"></i>
            Add Product
          </button>
          <span *ngIf="isSubscriber !== '1' && totalOrdersCount > 50"
            style="font-size: 11px; color: #dc2626; font-weight: 500;">
            Locked: Please subscribe to continue.
          </span>
        </div>
      </div>

      <table>
        <thead>
          <tr>
            <th>Product Name</th>
            <th>Base Price (RM)</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let product of products">
            <td><strong>{{ product.name }}</strong></td>
            <td>{{ product.price | number:'1.2-2' }}</td>
            <td>
              <div class="action-btn-group">
                <button class="edit-btn" (click)="editProduct(product.id)" title="Update Product">
                  <i class="fa fa-pen-to-square" style="margin-right: 4px;"></i> Update
                </button>
                <button class="delete-btn" (click)="deleteProduct(product.id)" title="Delete Product">
                  <i class="fa fa-trash" style="margin-right: 4px;"></i> Delete
                </button>
              </div>
            </td>
          </tr>

          <tr *ngIf="products.length === 0">
            <td colspan="3" class="empty-state">
              <i class="fa fa-mobile-screen-button" style="margin-right: 6px;"></i> No products. Please add your product
            </td>
          </tr>
        </tbody>
      </table>
    </section>

    <section class="products-card" *ngIf="activeTab === 'expenses'">
      <div class="card-header-actions">
        <h2>Business Expenses</h2>
        <div style="display: flex; flex-direction: column; align-items: flex-end; gap: 4px;">
          <button class="add-product-btn" [disabled]="isSubscriber !== '1' && totalOrdersCount > 50"
            [style.opacity]="(isSubscriber !== '1' && totalOrdersCount > 50) ? '0.6' : '1'"
            [style.cursor]="(isSubscriber !== '1' && totalOrdersCount > 50) ? 'not-allowed' : 'pointer'"
            (click)="isSubscriber !== '1' && totalOrdersCount > 50 ? null : openAddExpenseModal()"
            style="white-space: nowrap;">
            <i class="fa fa-lock" *ngIf="isSubscriber !== '1' && totalOrdersCount > 50" style="margin-right: 4px;"></i>
            <i class="fa fa-plus" *ngIf="!(isSubscriber !== '1' && totalOrdersCount > 50)"
              style="margin-right: 4px;"></i>
            Record Expense
          </button>
          <span *ngIf="isSubscriber !== '1' && totalOrdersCount > 50"
            style="font-size: 11px; color: #dc2626; font-weight: 500;">
            Locked: Please subscribe to continue.
          </span>
        </div>
      </div>

      <table>
        <thead>
          <tr>
            <th style="width: 10%;">No</th>
            <th style="width: 45%;">Item</th>
            <th style="width: 20%; text-align: right;">Price (RM)</th>
            <th style="width: 25%; text-align: center;">Action</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let expense of expenses; let i = index">
            <td><code class="sku-badge">{{ i + 1 }}</code></td>
            <td><strong>{{ expense.itemName }}</strong></td>
            <td style="text-align: right;"><strong>RM {{ expense.amount | number:'1.2-2' }}</strong></td>
            <td>
              <div class="action-btn-group" style="justify-content: center;">
                <button class="edit-btn" (click)="editExpense(expense.id)" title="Update Expense"
                  style="margin-right: 4px;">
                  <i class="fa fa-pen-to-square" style="margin-right: 4px;"></i> Update
                </button>
                <button class="delete-btn" (click)="deleteExpense(expense.id)" title="Delete Expense">
                  <i class="fa fa-trash" style="margin-right: 4px;"></i> Delete
                </button>
              </div>
            </td>
          </tr>

          <tr *ngIf="!expenses || expenses.length === 0">
            <td colspan="4" class="empty-state">
              <i class="fa fa-wallet" style="margin-right: 6px;"></i> No operating expenses recorded today. Tap the
              button above to add costs.
            </td>
          </tr>
        </tbody>
      </table>
    </section>

    <section class="products-card" *ngIf="activeTab === 'profile'">
      <div class="card-header-actions">
        <h2>Merchant Profile & Bank Info</h2>
        <button class="add-product-btn" (click)="openEditProfileModal()">
          <i [class]="merchantProfile ? 'fa fa-pen-to-square' : 'fa fa-plus'" style="margin-right: 4px;"></i> {{
          merchantProfile ? 'Edit Profile Info' : 'Add Profile Info' }}
        </button>
      </div>

      <table>
        <thead>
          <tr>
            <th>Business Name</th>
            <th>Bank Name</th>
            <th>Bank Account</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngIf="merchantProfile">
            <td><strong>{{ merchantProfile.businessName }}</strong></td>
            <td>{{ merchantProfile.bankName }}</td>
            <td class="bank-account-cell">
              <span>{{ showBankAccount ? merchantProfile.bankAccount : maskBankAccount(merchantProfile.bankAccount) }}</span>
              <button type="button" class="eye-toggle-btn" (click)="toggleBankAccountVisibility()"
                [attr.aria-label]="showBankAccount ? 'Hide bank account number' : 'Show bank account number'">
                <i [class]="showBankAccount ? 'fa fa-eye-slash' : 'fa fa-eye'"></i>
              </button>
            </td>
          </tr>
          <tr *ngIf="!merchantProfile">
            <td colspan="4" class="empty-state">
              <i class="fa fa-building-columns" style="margin-right: 6px;"></i> No merchant profile saved yet. Click the
              button above to set it up.
            </td>
          </tr>
        </tbody>
      </table>
    </section>

    <div class="modal-backdrop" *ngIf="currentModal !== 'NONE'">

      <div class="generate-modal" *ngIf="currentModal === 'GENERATE_LINK'">
        <div class="modal-header">
          <h2>Generate New Link</h2>
          <span class="close-btn" (click)="closeModal()">&times;</span>
        </div>

        <div class="form-group">
          <label>Select Product</label>
          <input type="text" placeholder="Enter Product">
        </div>

        <div class="form-group">
          <label>Total Payment (RM)</label>
          <input type="text" placeholder="RM 15.00">
        </div>

        <button class="paid-btn" style="width: 100%; justify-content: center; height: 46px; margin-bottom: 14px;">
          Generate Link & Copy
        </button>

        <div class="form-group">
          <label>Generated Link</label>
          <div class="copy-input-wrapper">
            <input type="text" #linkInput value="notabayar.my/o/ali9823" readonly />
            <button type="button" class="copy-btn" (click)="copyLink(linkInput.value)">
              <i class="fa fa-copy"></i>
            </button>
          </div>
        </div>
      </div>

      <!-- ADD ORDER MODAL -->
      <div class="modal-backdrop" *ngIf="currentModal === 'ADD_ORDER'">
        <div class="generate-modal" style="max-width: 650px;">
          <div class="modal-header"
            style="display: flex; justify-content: space-between; align-items: center; border-bottom: 1px solid #f3f4f6; padding-bottom: 12px; margin-bottom: 16px;">
            <h2 style="font-size: 20px; font-weight: 700; color: #111827; margin: 0; padding: 0; border: none;">Add
              Order Details</h2>
            <button type="button" class="close-btn" (click)="closeModal()"
              style="background: #f3f4f6; border: none; width: 32px; height: 32px; border-radius: 50%; font-size: 18px; color: #4b5563; cursor: pointer; display: flex; align-items: center; justify-content: center; padding: 0;">&times;</button>
          </div>

          <div class="form-grid">
            <!-- Order Items spans the full width of the grid -->
            <div class="form-group full-width" style="grid-column: 1 / -1;">
              <label style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 8px;">
                <span>Order Items</span>
                <button class="add-product-btn" (click)="addOrderItemRow()" style="white-space: nowrap;"><i
                    class="fa fa-plus" style="margin-right: 4px;"></i> Add
                  Order</button>
              </label>

              <!-- Dynamic Items Loop -->
              <div *ngFor="let item of selectedItem.items; let i = index"
                style="display: flex; gap: 10px; margin-bottom: 10px; align-items: center; background: #f8fafc; padding: 10px; border-radius: 6px;">

                <select [(ngModel)]="item.productId" name="productSelect_{{i}}" class="form-control"
                  style="flex: 2; min-width: 0;">
                  <option value="" disabled selected>Choose Product</option>
                  <option *ngFor="let p of getProductDropdownOptions()" [ngValue]="p.id">{{ p.name }} (RM {{ p.price }})
                  </option>
                </select>

                <input type="number" [(ngModel)]="item.quantity" name="quantity_{{i}}" placeholder="Qty"
                  class="form-control" style="flex: 1; min-width: 0;" min="1">

                <button type="button" class="delete-btn" style="padding: 8px 12px;" (click)="removeOrderItemRow(i)"
                  *ngIf="selectedItem.items.length > 1" title="Remove Item"><i class="fa fa-trash"></i>Delete</button>
              </div>
            </div>

            <!-- Customer Name -->
            <div class="form-group">
              <label>Customer Name</label>
              <input type="text" [(ngModel)]="selectedItem.customerName" name="customerName" class="form-control">
            </div>

            <!-- Phone Number -->
            <div class="form-group">
              <label>Phone Number</label>
              <input type="text" [(ngModel)]="selectedItem.customerPhoneNumber" name="customerPhoneNumber"
                class="form-control">
            </div>

            <!-- Customer Address spans the full width of the grid at the bottom -->
            <div class="form-group full-width" style="grid-column: 1 / -1;">
              <label>Customer Address</label>
              <input type="text" [(ngModel)]="selectedItem.customerAddress" name="customerAddress" class="form-control">
            </div>
          </div>

          <button class="paid-btn" style="width: 100%; justify-content: center; height: 46px; margin-top: 10px;"
            (click)="submitAddOrder()"><i class="fa fa-floppy-disk" style="margin-right: 6px;"></i> Save Order</button>
        </div>
      </div>

      <!-- EDIT ORDER MODAL -->
      <div class="generate-modal" *ngIf="currentModal === 'EDIT_ORDER'" style="max-width: 650px;">
        <div class="modal-header"
          style="display: flex; justify-content: space-between; align-items: center; border-bottom: 1px solid #f3f4f6; padding-bottom: 12px; margin-bottom: 16px;">
          <h2 style="font-size: 20px; font-weight: 700; color: #111827; margin: 0; padding: 0; border: none;">Update
            Order Details</h2>
          <button type="button" class="close-btn" (click)="closeModal()"
            style="background: #f3f4f6; border: none; width: 32px; height: 32px; border-radius: 50%; font-size: 18px; color: #4b5563; cursor: pointer; display: flex; align-items: center; justify-content: center; padding: 0;">&times;</button>
        </div>

        <div class="form-grid" *ngIf="selectedItem">
          <!-- Order Items spans the full width of the grid -->
          <div class="form-group full-width" style="grid-column: 1 / -1;">
            <label style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 8px;">
              <span>Order Items</span>
              <button type="button" class="add-product-btn" style="padding: 4px 10px; font-size: 12px;"
                (click)="addOrderItemRow()"><i class="fa fa-plus" style="margin-right: 4px;"></i> Add Item</button>
            </label>

            <div *ngFor="let item of selectedItem.items; let i = index"
              style="display: flex; gap: 10px; margin-bottom: 10px; align-items: center; background: #f8fafc; padding: 10px; border-radius: 6px;">
              <select [(ngModel)]="item.productId" name="editProductSelect_{{i}}" class="form-control"
                style="flex: 2; min-width: 0;">
                <option value="" disabled selected>Pilih Produk</option>
                <option *ngFor="let p of products" [ngValue]="p.id">
                  {{ p.name }} (RM {{ p.price }})
                </option>
              </select>

              <input type="number" [(ngModel)]="item.quantity" name="editQuantity_{{i}}" class="form-control"
                style="flex: 1; min-width: 0;" min="1" placeholder="Qty">

              <button type="button" class="delete-btn" style="padding: 8px 12px;" (click)="removeOrderItemRow(i)"
                *ngIf="selectedItem.items.length > 1" title="Remove Item"><i class="fa fa-trash"></i></button>
            </div>
          </div>

          <!-- Customer Name -->
          <div class="form-group">
            <label>Customer Name</label>
            <input type="text" [(ngModel)]="selectedItem.customerName" name="editCustomerName" class="form-control">
          </div>

          <!-- Phone Number -->
          <div class="form-group">
            <label>Phone Number</label>
            <input type="text" [(ngModel)]="selectedItem.customerPhoneNumber" name="editCustomerPhoneNumber"
              class="form-control">
          </div>

          <!-- Customer Address spans the full width of the grid at the bottom -->
          <div class="form-group full-width" style="grid-column: 1 / -1;">
            <label>Customer Address</label>
            <input type="text" [(ngModel)]="selectedItem.customerAddress" name="editCustomerAddress"
              class="form-control">
          </div>
        </div>

        <button class="paid-btn" style="width: 100%; justify-content: center; height: 46px; margin-top: 10px;"
          (click)="saveOrderUpdate()"><i class="fa fa-floppy-disk" style="margin-right: 6px;"></i> Save Changes</button>
      </div>

      <div class="generate-modal" *ngIf="currentModal === 'ADD_PRODUCT'">

        <div class="modal-header"
          style="display: flex; justify-content: space-between; align-items: center; border-bottom: 1px solid #f3f4f6; padding-bottom: 12px; margin-bottom: 16px;">
          <h2 style="font-size: 20px; font-weight: 700; color: #111827; margin: 0; padding: 0; border: none;">Add New
            Product</h2>
          <button type="button" class="close-btn" (click)="closeModal()"
            style="background: #f3f4f6; border: none; width: 32px; height: 32px; border-radius: 50%; font-size: 18px; color: #4b5563; cursor: pointer; display: flex; align-items: center; justify-content: center; padding: 0;">&times;</button>
        </div>

        <div class="form-group" style="margin-top: 14px;">
          <label>Product Name</label>
          <input type="text" [(ngModel)]="newProduct.name" placeholder="e.g. Sambal Garing Che Nor">
        </div>

        <div class="form-group">
          <label>Base Price (RM)</label>
          <input type="number" [(ngModel)]="newProduct.price" placeholder="0.00">
        </div>

        <button class="paid-btn" style="width: 100%; justify-content: center; height: 46px; margin-top: 10px;"
          (click)="submitAddProduct()">
          <i class="fa fa-plus" style="margin-right: 6px;"></i> Add to Catalog
        </button>
      </div>

      <div class="generate-modal" *ngIf="currentModal === 'EDIT_PRODUCT'">
        <div class="modal-header"
          style="display: flex; justify-content: space-between; align-items: center; border-bottom: 1px solid #f3f4f6; padding-bottom: 12px; margin-bottom: 16px;">
          <h2 style="font-size: 20px; font-weight: 700; color: #111827; margin: 0; padding: 0; border: none;">Update
            Product Information</h2>
          <button type="button" class="close-btn" (click)="closeModal()"
            style="background: #f3f4f6; border: none; width: 32px; height: 32px; border-radius: 50%; font-size: 18px; color: #4b5563; cursor: pointer; display: flex; align-items: center; justify-content: center; padding: 0;">&times;</button>
        </div>

        <div class="form-group" style="margin-top: 14px;" *ngIf="selectedItem">
          <label>Product Name</label>
          <input type="text" [(ngModel)]="selectedItem.name">
        </div>

        <div class="form-group" *ngIf="selectedItem">
          <label>Base Price (RM)</label>
          <input type="number" [(ngModel)]="selectedItem.price">
        </div>

        <button class="paid-btn" style="width: 100%; justify-content: center; height: 46px; margin-top: 10px;"
          (click)="saveProductUpdate()">
          <i class="fa fa-floppy-disk" style="margin-right: 6px;"></i> Update Product
        </button>
      </div>

      <div class="generate-modal" *ngIf="currentModal === 'ADD_EXPENSE'">
        <div class="modal-header"
          style="display: flex; justify-content: space-between; align-items: center; border-bottom: 1px solid #f3f4f6; padding-bottom: 12px; margin-bottom: 16px;">
          <h2 style="font-size: 20px; font-weight: 700; color: #111827; margin: 0; padding: 0; border: none;">Add
            Expenses Record</h2>
          <button type="button" class="close-btn" (click)="closeModal()"
            style="background: #f3f4f6; border: none; width: 32px; height: 32px; border-radius: 50%; font-size: 18px; color: #4b5563; cursor: pointer; display: flex; align-items: center; justify-content: center; padding: 0;">&times;</button>
        </div>

        <div class="form-group" style="margin-top: 14px;">
          <label>Item Name / Description</label>
          <input type="text" [(ngModel)]="newExpense.itemName" placeholder="e.g. Bubble Wrap Thick Roll">
        </div>

        <div class="form-group">
          <label>Total Amount (RM)</label>
          <input type="number" [(ngModel)]="newExpense.amount" placeholder="0.00">
        </div>

        <button class="delete-btn"
          style="width: 100%; justify-content: center; height: 46px; background: #1f2937; margin-top: 10px;"
          (click)="submitAddExpense()">
          Save Expenses
        </button>
      </div>

      <div class="generate-modal" *ngIf="currentModal === 'EDIT_EXPENSE'">
        <div class="modal-header"
          style="display: flex; justify-content: space-between; align-items: center; border-bottom: 1px solid #f3f4f6; padding-bottom: 12px; margin-bottom: 16px;">
          <h2 style="font-size: 20px; font-weight: 700; color: #111827; margin: 0; padding: 0; border: none;">Update
            Expenses Record</h2>
          <button type="button" class="close-btn" (click)="closeModal()"
            style="background: #f3f4f6; border: none; width: 32px; height: 32px; border-radius: 50%; font-size: 18px; color: #4b5563; cursor: pointer; display: flex; align-items: center; justify-content: center; padding: 0;">&times;</button>
        </div>

        <div class="form-group" style="margin-top: 14px;" *ngIf="selectedItem">
          <label>Item Name / Description</label>
          <input type="text" [(ngModel)]="selectedItem.itemName">
        </div>

        <div class="form-group" *ngIf="selectedItem">
          <label>Total Amount (RM)</label>
          <input type="number" [(ngModel)]="selectedItem.amount">
        </div>

        <button class="paid-btn" style="width: 100%; justify-content: center; height: 46px; margin-top: 10px;"
          (click)="saveExpenseUpdate()">
          Update Expense
        </button>
      </div>

      <div class="generate-modal" *ngIf="currentModal === 'EDIT_PROFILE'">
        <div class="modal-header"
          style="display: flex; justify-content: space-between; align-items: center; border-bottom: 1px solid #f3f4f6; padding-bottom: 12px; margin-bottom: 16px;">
          <h2 style="font-size: 20px; font-weight: 700; color: #111827; margin: 0; padding: 0; border: none;">Update
            Merchant Profile</h2>
          <button type="button" class="close-btn" (click)="closeModal()"
            style="background: #f3f4f6; border: none; width: 32px; height: 32px; border-radius: 50%; font-size: 18px; color: #4b5563; cursor: pointer; display: flex; align-items: center; justify-content: center; padding: 0;">&times;</button>
        </div>

        <div class="form-group" style="margin-top: 14px;">
          <label>Business Name</label>
          <input type="text" [(ngModel)]="editProfileData.businessName" placeholder="e.g. Kedai Runcit Ali">
        </div>

        <div class="form-group">
          <label>Bank Name</label>
          <input type="text" [(ngModel)]="editProfileData.bankName" placeholder="e.g. Maybank">
        </div>

        <div class="form-group">
          <label>Bank Account Number</label>
          <input type="text" [(ngModel)]="editProfileData.bankAccount" placeholder="e.g. 114012345678">
        </div>

        <button class="paid-btn" style="width: 100%; justify-content: center; height: 46px; margin-top: 10px;"
          (click)="saveProfileUpdate()">
          Save Profile
        </button>
      </div>

    </div>

  </main>
</div>